export class VegobjekterStatisticsResponseGruppertByFylke {
    constructor(
        readonly antall: number,
        readonly lengde: number,
        readonly fylke: number
    ) {}
}

export class VegobjekterStatisticsResponseGruppertByKommune {
    constructor(
        readonly antall: number,
        readonly lengde: number,
        readonly kommune: number
    ) {}
}

export class VegobjekterStatisticsByKategoriResponseGruppert {
    constructor(
        readonly antall: number,
        readonly lengde: number,
        readonly vegkategori: string
    ) {}
}

export class AllVegobjekterStatisticsResponseGruppert {
    constructor(
        readonly antall: number,
        readonly lengde: number,
        readonly vegkategori: string,
        readonly fylke: number,
        readonly kommune: number
    ) {}
}

export class VegobjekterStatisticsResponseGruppertByEgenskap {
    constructor(
        readonly antall: number,
        readonly lengde: number,
        readonly egenskapsVerdi: string | null
    ) {}
}
